import { render, staticRenderFns } from "./AdsCampaignTabLinks.vue?vue&type=template&id=67fa8585"
import script from "./AdsCampaignTabLinks.vue?vue&type=script&lang=js"
export * from "./AdsCampaignTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports